<template>
  <div class="join-board-view">
    <div class="join-container card">
      <div v-if="isLoading" class="loading-state">
        <div class="spinner"></div>
        <h2>ボードに参加しています...</h2>
        <p>しばらくお待ちください。</p>
      </div>

      <div v-else-if="error" class="error-state">
        <div class="error-icon">!</div>
        <h2>招待リンクを確認してください</h2>
        <p class="error-message">{{ error }}</p>
        <router-link to="/mypage" class="btn btn-primary">
          マイページに戻る
        </router-link>
      </div>

    </div>
  </div>
</template>

<script>
import { ref, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import axios from "axios";
import { API_URL } from "@/config/api.js";
import {
  createGuestId,
  saveDestinationBoardGuestSession,
} from "@/utils/guest-session.js";

const joinApiClient = axios;
export default {
  name: "JoinDestinationBoard",
  setup() {
    const route = useRoute();
    const router = useRouter();
    const isLoading = ref(true);
    const error = ref(null);
    const guestId = ref(createGuestId());

    const joinAsGuest = async () => {
      const shareToken = route.params.token;
      isLoading.value = true;
      error.value = null;
      try {
        const response = await joinApiClient.post(
          `${API_URL}/destination-boards/join/${shareToken}/guest`,
          {
            guestId: guestId.value,
          }
        );
        const boardId =
          response.data?.boardId ||
          response.data?.board_id ||
          response.data?.destinationBoardId ||
          response.data?.BOARD_ID;
        if (!boardId) {
          throw new Error("ボードIDの取得に失敗しました");
        }
        saveDestinationBoardGuestSession({
          ...response.data,
          boardId,
          guestId: guestId.value,
          guestName: response.data?.guestName || response.data?.guest_name || response.data?.memberName || response.data?.member_name,
          memberCode:
            response.data?.memberCode ||
            response.data?.member_code ||
            response.data?.MEMBER_CODE ||
            response.data?.member?.MEMBER_CODE ||
            response.data?.member?.memberCode ||
            response.data?.member?.member_code,
        });
        router.push(`/destination-board/${boardId}`);
      } catch (err) {
        console.error("Guest join board error", {
          status: err.response?.status || null,
        });
        error.value = "参加に失敗しました。招待リンクを確認してもう一度お試しください。";
      } finally {
        isLoading.value = false;
      }
    };

    onMounted(async () => {
      const shareToken = route.params.token;
      const authToken = localStorage.getItem("token");

      if (!authToken) {
        await joinAsGuest();
        return;
      }

      try {
        // ログイン済みユーザーは通常の招待参加 API を使う。
        const response = await axios.get(
          `${API_URL}/destination-boards/join/${shareToken}`,
          {
            headers: {
              Authorization: `Bearer ${authToken}`
            }
          }
        );
        const boardId = response.data?.boardId || response.data?.BOARD_ID;
        if (boardId) {
          router.push(`/destination-board/${boardId}`);
        } else {
          throw new Error("ボードIDの取得に失敗しました");
        }
      } catch (err) {
        console.error("Join board error", {
          status: err.response?.status || null,
        });
        error.value = "参加に失敗しました。招待リンクを確認してもう一度お試しください。";
      } finally {
        isLoading.value = false;
      }
    });

    return {
      isLoading,
      error,
      joinAsGuest,
    };
  },
};
</script>

<style scoped>
.join-board-view {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--color-background);
  padding: 1rem;
}

.join-container {
  max-width: 450px;
  width: 100%;
  padding: 3rem 2rem;
  text-align: center;
  background: var(--color-surface);
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
  border: 1px solid var(--color-border);
}

.loading-state, .error-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}


.spinner {
  width: 50px;
  height: 50px;
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-top-color: var(--primary-color);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.error-icon {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: var(--color-danger-light);
  color: var(--color-danger);
  font-size: 2rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem;
}

.error-message {
  color: var(--text-muted);
  font-size: 0.9375rem;
  margin-bottom: 1.5rem;
}

.btn {
  display: inline-block;
  padding: 0.75rem 2rem;
  font-weight: 700;
  border-radius: 8px;
  text-decoration: none;
  cursor: pointer;
  transition: background-color 0.2s;
}

.btn-primary {
  background-color: var(--primary-color);
  color: white;
}

.btn-primary:hover {
  background-color: var(--primary-hover);
}
</style>




